import { createSlice } from '@reduxjs/toolkit';
import { AllPopWinState } from './state';
import { PopupWinReducer } from './reducer';
import './controller';
const popupWinSlice = createSlice({
    name: 'popupWin',
    initialState: AllPopWinState,
    reducers: PopupWinReducer,
});
const { actions } = popupWinSlice;
export { actions };
export default popupWinSlice.reducer;
